import { post } from '../utils/httpInterceptor';

class BpmGatewayService {
  static async publishBpmn(idModeler) {
    return post(`/bpm-gateway/repository/deployments/${idModeler}`, {});
  }
}

export default BpmGatewayService;
